import { render, staticRenderFns } from "./updateCMCF.vue?vue&type=template&id=a4b5b898&lang=pug&"
import script from "./updateCMCF.vue?vue&type=script&lang=js&"
export * from "./updateCMCF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports